<template>
    <ValidationProvider rules="max:10000">
        <quill-editor
            v-model="text"
            @change="emitFieldData"
        />
    </ValidationProvider>
</template>

<script>
import InputBoilerplate from '@/views/Common/Input/InputBoilerplate';
import { EventBus } from '@/store/eventBus';

export default {
    mixins: [ InputBoilerplate ],

    data() {
        return {
            text: '',
        };
    },

    methods: {
        loadFieldData() {
            this.text = this.inputData;
        },

        emitFieldData() {
            EventBus.$emit(`${this.namespace}UpdateFieldData`, {
                text: this.text,
            });
        }
    }
};
</script>
